import MyBookingsOverview from "../components/Admin/my-bookings-overview";


export default function MisReservas() {
    return (
        <main className="container mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Mis Reservas</h1>
                <p className="text-gray-600">Gestiona y revisa todas tus reservas</p>
            </div>
            <MyBookingsOverview />
        </main>
    )
}
